import PropTypes from "prop-types";
import React from 'react'


const SEO = ({ title }) => {
    return (
        <>
            <meta charSet="utf-8" />
            <meta name="theme-color" content="#ffffff" />
            <title>India Web Design | Vancouver Web Development | Web Design Agency</title>
            <meta name="description" content="Web Design India - YGS Web Solutions PVT. LTD. is a India web design company offering unique and affordable web design, development and eCommerce website design solutions in India" /><meta name="robots" content="index, follow, max-video-preview:-1, max-image-preview:large, max-snippet:-1" />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;


